import { FloatLabel } from 'primereact/floatlabel';
import { InputText } from 'primereact/inputtext';

import React, { useId } from 'react';

interface FloatLabelInputProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  error?: string;
  className?: string;
  inputClassName?: string;
  required?: boolean;
  disabled?: boolean;
}

const FloatLabelInput: React.FC<FloatLabelInputProps> = ({
  label,
  value,
  onChange,
  error,
  className = '',
  inputClassName = '',
  required = false,
  disabled = false,
}) => {
  const id = useId();

  return (
    <div className={`${className} field`}>
      <FloatLabel>
        <InputText
          id={id}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          className={`${inputClassName} w-full ${error ? 'p-invalid' : ''}`}
          required={required}
          disabled={disabled}
          aria-describedby={`${id}-help`}
          aria-invalid={!!error}
        />
        <label htmlFor={id}>
          {label}
          {required && ' *'}
        </label>
      </FloatLabel>
      {error && (
        <small id={`${id}-help`} className="p-error">
          {error}
        </small>
      )}
    </div>
  );
};

export default FloatLabelInput;
